import { render, staticRenderFns } from "./b2b-list-customers.vue?vue&type=template&id=ce57b07a"
import script from "./b2b-list-customers.vue?vue&type=script&lang=js"
export * from "./b2b-list-customers.vue?vue&type=script&lang=js"
import style0 from "./b2b-list-customers.vue?vue&type=style&index=0&id=ce57b07a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports